import React, { useState, useEffect } from 'react';
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, IconButton, Alert } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { Link as RouterLink } from 'react-router-dom';
import axios from 'axios';
import config from '../config';

const Groupings = () => {
    const [groups, setGroups] = useState([]);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState(null);

    useEffect(() => {
        fetchGroups();
    }, []);

    const fetchGroups = async () => {
        try {
            const response = await axios.get(`${config.API_BASE_URL}/groups`);
            setGroups(response.data);
        } catch (err) {
            console.error(err);
            setError('Failed to load groups');
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this group?')) return;

        try {
            await axios.delete(`${config.API_BASE_URL}/groups/${id}`);
            setMessage('Group deleted successfully');
            fetchGroups();
        } catch (err) {
            console.error(err);
            setError('Failed to delete group');
        }
    };

    return (
        <Box>
            <Typography variant="h4" gutterBottom>Groupings</Typography>

            {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Source Table</TableCell>
                            <TableCell>Created At</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {groups.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={4} align="center">No groups created yet</TableCell>
                            </TableRow>
                        ) : (
                            groups.map((group) => (
                                <TableRow key={group.id}>
                                    <TableCell>
                                        <Button
                                            component={RouterLink}
                                            to={`/groupings/${group.id}`}
                                            sx={{ textTransform: 'none', fontWeight: 'bold' }}
                                        >
                                            {group.name}
                                        </Button>
                                    </TableCell>
                                    <TableCell>{group.table_name}</TableCell>
                                    <TableCell>{new Date(group.created_at).toLocaleString()}</TableCell>
                                    <TableCell>
                                        <IconButton color="secondary" onClick={() => handleDelete(group.id)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default Groupings;
